import PublicLayout from '../components/layouts/PublicLayout';
import { Container } from 'reactstrap';
import {useState} from 'react';
import axios from 'axios';
import Head from 'next/head';
import { useRouter } from 'next/router'
import { useEffect } from 'react';

function Privacy({meta}) {
    const [loading, setLoading] = useState(false); 
    const router = useRouter();

	return (
        <>
        	<Head>
	            <meta name="keywords" content={meta ? meta.keywords : ''} />
	            <title>{meta ? meta.title : ''}</title>
	            <meta name="description" content={meta ? meta.description : ''} />
	            <link rel="canonical" href={process.env.NEXT_PUBLIC_APP_URL + router.asPath} />
	        </Head>
  			<div className="banner_breadcrumb_section" id="privacy">
				<div id="spinner" className="spinner_req_review" style={{"display": loading ? "block" : "none"}}>
					<div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
				</div>
				<Container fluid="xl">
					<h1 className="main-heading-lg">Privacy</h1>
				</Container>
			  </div>
			<Container fluid="xl">
			  <div className="terms-section-set  padding-set" >
			  <div className="content-wrap-set">
					<p>
					At Toprow, we take utmost care to ensure that your privacy is protected. We want you to know that you are safe when you are on our platform and can connect with vendors or businesses without worrying about privacy violations. Privacy is important to us and we prioritize protecting every information you share with us. We ensure that data shared on our platform is secure and inaccessible to unauthorized third parties. This privacy policy (&#34;Policy&#34;) describes how we collect and use data when you perform or acquire services using our website or interact with us directly.
					</p>
					<p>
					If you do not agree with this Policy, do not use our products or provide Toprow with your personal data.
					</p>
			  </div>
			  <div className="content-wrap-set">
					<h4>
					Information We Collect
					</h4>
					<p>
					We collect personal data when you sign up for an account or build a profile on Toprow. When you sign up for a free download or ask to be added to our mailing lists, you will also be requested to provide your personal data. We may also collect your personal data when verifying you as a vendor and some of this information may be made available to businesses seeking talent on our platform. 
					</p>
				</div>
				<div className="content-wrap-set">
					<h4>
					Site Usage
					</h4>
					<p>
					We typically record information such as your IP address, access times, content viewed or requested, features used, browser or application time, language and other similar information when you use our platform.
					</p>
				</div>
				<div className="content-wrap-set">
					<h4>
					Information You Provide Us
					</h4>
					<p>
					When you interact with us, we may ask for your personal data and other information that are necessary for completing the task at hand. Such information could include your usernames and passwords, email address, phone number, location, language, and more. We maintain records of your consents, preferences and settings such as your location and demography.
					</p>
				</div>
				<div className="content-wrap-set">
					<h4>
					Why We Process Personal Data
					</h4>
					<p>
					At Toprow we process your personal data for the purposes below. One or more of them may apply simultaneously.
					</p>
				</div>
				<div className="content-wrap-set">
					<h4>
					Usage of Our Platform
					</h4>
					<p>
					We collect your personal data to enable us to set you up on our platform. We also collect your data to process your requests and to fulfill the contract between you and Toprow when you obtain services or clients on our platform. We may use the data to ensure the functionality and security of our products and services, to identify you and to prevent and investigate misuse or fraud.
					</p>
				</div>
				<div className="content-wrap-set">
					<h4>
					Accounts
					</h4>
					<p>
					We require you to create an account on our platform that helps personalize your experience. You will need to provide us with your personal data when you do this. You may also be required to provide further details about yourself such as your skills when creating a profile.
					</p>
				</div>
				<div className="content-wrap-set">
					<h4>
					Developing and Managing Products and Services
					</h4>
					<p>
					We may use your personal data during the development of new products and services and in marketing, sales and customer support. Depending on what it is being used for, your personal data may be anonymized. We may use data relating to access and usage of our platform along with data that you provided unless where one form of data is incompatible with this purpose.
					</p>
				</div>
				<div className="content-wrap-set">
					<h4>
					Communicating With You
					</h4>
					<p>
					We may use your personal data in communications such as informing you about our services, sending you alerts, notifying you about changes and for customer support purposes.
					</p>
				</div>
				<div className="content-wrap-set">
					<h4>
					Marketing, Advertising and Recommendations
					</h4>
					<p>
					We may use your personal data when we contact you to let you know about new products, services, promotions, market research and more.
					</p>
				</div>
				<div className="content-wrap-set">
					<h4>
					Legal Basis for Processing Your Personal Data
					</h4>
					<p>
					Our legal basis for processing your personal data depends on the purpose for processing it, and your consent. Here are a few legal bases for processing your data.
					</p>
				</div>
				<div className="content-wrap-set">
					<h4>
					Your Consent
					</h4>
					<p>
					We process your personal data if you have provided us with your consent. You can revoke your consent at any time. When you do this, we will stop processing your data. Such revocation will not have an impact on data processed before it was effected.
					</p>
				</div>
				<div className="content-wrap-set">
					<h4>
					Performance of a Contract with You
					</h4>
					<p>
					We process your personal data to perform our obligations under our contract with you that was entered into when you signed up on our platform.
					</p>
				</div>
				<div className="content-wrap-set">
					<h4>
					Legal Obligations
					</h4>
					<p>
					We process your personal data to comply with existing applicable laws and obligations.
					</p>
				</div>
				<div className="content-wrap-set">
					<h4>
					Legitimate Interests
					</h4>
					<p>
					We process your personal data in furtherance of our legitimate interests such as in connection with managing, developing, testing, securing our products and services, and in marketing circumstances or making recommendations regarding our talent marketplace. This is subject to measures implemented to safeguard your fundamental rights and freedom related to your personal data.
					</p>
				</div>
				<div className="content-wrap-set">
					<h4>
					How Long Do We Retain Personal Data?
					</h4>
					<p>
					We collect personal data only in circumstances in which it is absolutely necessary to do so. We retain such data for no longer than is necessary to fulfill the processing purposes. The reason for the data collection and the nature of the personal data determines the length of time for which such data is retained. 
					</p>
				</div>
				<div className="content-wrap-set">
					<h4>
					Personal Data Sharing
					</h4>
					<p>
					We do not share your personal data in any way such as selling, leasing, or disclosing such data to third parties. We may share your data if you have given us the consent to do so. We may also share your personal data with authorized third parties who process personal data for Toprow for purposes such as billing, customer service, managing and analyzing consumer data, conducting research, managing marketing campaigns, and so on.
					</p>
					<p>
					We may conduct joint marketing campaigns with our partners such as hosting or speaking at a podcast or conference. These authorized third parties are not permitted to use your personal data for any other purposes.
					</p>
				</div>
				<div className="content-wrap-set">
					<h4>
					Mandatory Disclosures
					</h4>
					<p>
					We may be obligated by law to disclose your personal data to certain authorities or third parties. Examples of such disclosures include to law enforcement agencies in countries where we operate, during legal proceedings involving Toprow, and governmental filings or requests.
					</p>
				</div>
				<div className="content-wrap-set">
					<h4>
					How do we safeguard your personal data?
					</h4>
					<p>
					We have set up internal policies for safeguarding personal data that we collect. These policies address security, data loss and data quality. We limit access to our databases that carry personal data to authorized persons. 
					</p>
				</div>
				<div className="content-wrap-set">
					<h4>
					Use of Cookies
					</h4>
					<p>
					We use cookies on our website to learn about people who are interested in our services. Cookies help us improve your experience on our site and focus on what our site visitors are interested in.
					</p>
				</div>
				<div className="content-wrap-set">
					<h4>
					Your Rights
					</h4>
					<p>
					You have a right to know what data we collect from you and to access such data. You have a right to request an update to your personal data where such data is incomplete, outdated or inaccurate. You have a right to request an erasure of your personal data and to obtain a copy of your data. You have a right to object to and to restrict processing of your data in certain circumstances. Such circumstances include where you think that the data is inaccurate, the processing activity is unlawful, or you want your personal data removed from our marketing campaigns. You can unsubscribe from our marketing messages at any time. You can exercise your privacy rights by contacting us. In some cases, we may be able to continue offering our service to you once data processing is nullified. 
					</p>
				</div>
				<div className="content-wrap-set">
					<h4>
					Changes to this Privacy Policy
					</h4>
					<p>
					We may change this Policy from time to time. We may also modify or withdraw access to this site without notice at any time. If there&#39;s a significant or adverse change to this policy, we will inform you through a notice on the site. You should visit this policy from time to time to learn of any such changes.
					</p>
				</div>
			  </div>
			</Container>	
        </>	
	)
}

// This gets called on every request
export async function getServerSideProps({ req, res}) {
    try {
        const response = await axios.get(process.env.NEXT_PUBLIC_API_URL+'metas?path=/privacy', { headers: {
            "Accept": "application/json" }
        });

        return { props: { meta: response.data.data,  } }

    } catch (err) {
        const meta = false;

        return { props: { meta } };
    }
}


Privacy.Layout = PublicLayout;

export default Privacy
